import React from 'react'

function Required() {
    return (
        <>
            <span className="text-red-500">*</span>
        </>
    )
}

export default Required
